<!-- Оборачивает форму редактирования категории расходов в базовую модалку -->
<template>
  <BaseModal
    :visible="true"
    title="Редактирование категории расходов"
    size="md"
    footer-align="between"
    elevated-footer
    @close="$emit('close')"
  >
    <base-loader v-if="dataIsLoading" />

    <ExpenseCategoryForm
      v-else
      ref="form"
      :initial-data="categoryData"
      :is-loading="isSubmitting"
      :hide-actions="true"
      @save="handleSave"
      @cancel="$emit('close')"
    />

    <template v-if="!dataIsLoading" #footer>
      <div class="footer-actions">
        <base-primary-button
          class="save-btn"
          type="button"
          @click="$refs.form.save()"
          :disabled="isSubmitting"
        >
          {{ isSubmitting ? "Сохранение..." : "Сохранить" }}
        </base-primary-button>
        <base-button
          class="cancel-btn"
          type="button"
          @click="$emit('close')"
          :disabled="isSubmitting"
        >
          Отмена
        </base-button>
      </div>

      <button
        class="toggle-btn"
        :class="{ 'toggle-btn--on': !categoryData.enabled }"
        type="button"
        @click="handleToggle"
        :disabled="isSubmitting"
      >
        {{ categoryData.enabled ? "Отключить" : "Включить" }}
      </button>
    </template>
  </BaseModal>
</template>

<script>
import { useNotificationStore } from "@/stores/notificationStore";
import { useExpenseCategoryStore } from "@/stores/expenseCategoryStore";

import expenseCategoriesApi from "@/services/api/expenseCategoriesApi";

import ExpenseCategoryForm from "@/components/Expense/ExpenseCategoryForm.vue";

export default {
  name: "EditCategoryModal",
  components: { ExpenseCategoryForm },
  props: {
    companyId: {
      type: Number,
      required: true,
    },
    categoryId: {
      type: Number,
      required: true,
    },
  },
  emits: ["close", "categories-updated"],
  data() {
    return {
      dataIsLoading: true,
      isSubmitting: false,
      categoryData: null,
    };
  },
  computed: {
    notificationStore() {
      return useNotificationStore();
    },
  },

  methods: {
    async getCategoryRequest() {
      try {
        const response = await expenseCategoriesApi.show(
          this.companyId,
          this.categoryId
        );
        this.categoryData = response.data.result;
      } catch (error) {
        console.error("Ошибка при загрузке категории", error);
      } finally {
        this.dataIsLoading = false;
      }
    },

    async handleSave(payload) {
      try {
        this.isSubmitting = true;
        const store = useExpenseCategoryStore();
        const updated = await store.updateExpenseCategory(
          this.categoryId,
          payload
        );
        this.notificationStore.showSuccess("Категория обновлена");
        this.$emit("categories-updated", updated);
        this.$emit("close");
      } catch {
        // ошибка обрабатывается в сторе
      } finally {
        this.isSubmitting = false;
      }
    },

    async handleToggle() {
      try {
        this.isSubmitting = true;
        const store = useExpenseCategoryStore();
        const updated = await store.toggleExpenseCategory(
          this.categoryId
        );
        this.notificationStore.showSuccess(
          this.categoryData.enabled
            ? "Категория отключена"
            : "Категория включена"
        );
        this.$emit("categories-updated", updated);
        this.$emit("close");
      } catch {
        // ошибка обрабатывается в сторе
      } finally {
        this.isSubmitting = false;
      }
    },
  },

  created() {
    this.getCategoryRequest();
  },
};
</script>

<style scoped>
.footer-actions {
  display: flex;
  gap: 8px;
}

.toggle-btn {
  padding: 8px 18px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  border: 1px solid var(--color-danger);
  color: var(--color-danger);
  background-color: #fff;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.toggle-btn:hover:not(:disabled) {
  background-color: var(--color-danger);
  color: #fff;
}

.toggle-btn--on {
  border-color: var(--color-green);
  color: var(--color-dark);
}

.toggle-btn--on:hover:not(:disabled) {
  background-color: var(--color-green);
  color: #fff;
}

.cancel-btn:hover:not(:disabled) {
  background-color: var(--color-grey);
}

.toggle-btn:disabled,
.cancel-btn:disabled,
.save-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

@media screen and (max-width: 767px) {
  .footer-actions {
    width: 100%;
    flex-direction: row-reverse;
  }

  .save-btn,
  .cancel-btn,
  .toggle-btn {
    flex: 1;
    text-align: center;
  }
}
</style>
